import React from 'react';
import { Container, Row, Col, Button} from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
import { IconArrowUpRight } from '@tabler/icons-react';

const Servicescontent = ({ conttitle, content , buttonlink, label }) => {
  const isLogin = useSelector((state) => state.isLogin);
  return (
    <>
      <section className='services-info'>
        <Container>
          <Row>
            <Col md={12}>
              <div class="head-title mb-4 text-start">
                <div class="sup">Services Details</div>
                <h2>
                  <span class="text-gradient">{conttitle}</span>
                </h2>
              </div>
              <div className="cont-box">
                {content}
              </div>
              <div className="d-flex align-items-center justify-content-start">
                <Button className='button yellow py-3 mt-3' as={Link} to={isLogin ? '/userrequestquote' : '/login'}>{label} <IconArrowUpRight size={20} stroke={2} /></Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Servicescontent